import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF", rotate }) => {
  return (
    <svg
      width="11"
      height="8"
      viewBox="0 0 11 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `rotate(${rotate || 0})` }}
    >
      <rect y="7.05884" width="11" height="0.941176" fill={fill} />
      <path
        d="M5.5 0V6.11765M5.5 6.11765L8 3.29412M5.5 6.11765L3 3.29412"
        stroke={fill}
      />
    </svg>
  );
};

export default memo(Icon);
